export interface ReinstateDirectDebitRequest {
  plan_number: string;
  last_name: string;
  postcode: string;
  email: string;
}
